import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=23a6e911&"
import script from "./Roles.vue?vue&type=script&lang=ts&"
export * from "./Roles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports